import { avatarColor, initials } from './format';

interface Props {
  name: string;
  size?: number;
}

export function ReviewerAvatar({ name, size = 28 }: Props) {
  const background = avatarColor(name);
  const fontSize = Math.round(size * 0.42);
  return (
    <span
      aria-hidden
      className="inline-flex items-center justify-center rounded-full text-white font-semibold flex-shrink-0 select-none"
      style={{
        width: size,
        height: size,
        fontSize,
        backgroundColor: background,
      }}
    >
      {initials(name)}
    </span>
  );
}
